(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werkbull-1050-tool-case-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tool-case-root]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const input = root.querySelector('[data-variant-input]');
    const price = root.querySelector('[data-selected-price]');
    const title = root.querySelector('[data-selected-title]');
    const description = root.querySelector('[data-selected-description]');
    const stock = root.querySelector('[data-stock-label]');
    const buy = root.querySelector('[data-buy-button]');
    const mobileBuy = root.querySelector('[data-mobile-buy]');
    const mobileTitle = root.querySelector('[data-mobile-title]');
    const mobilePrice = root.querySelector('[data-mobile-price]');

    root.querySelectorAll('[data-variant-option] input').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked || radio.disabled) return;
        const option = radio.closest('[data-variant-option]');
        root.querySelectorAll('[data-variant-option]').forEach((item) => item.classList.remove('is-selected'));
        option.classList.add('is-selected');
        input.value = option.dataset.variantId;
        price.textContent = option.dataset.variantPrice;
        title.textContent = option.dataset.variantTitle + ' части';
        description.textContent = option.dataset.variantDescription;
        stock.textContent = 'В наличност';
        buy.disabled = false;
        mobileBuy.disabled = false;
        mobileTitle.textContent = option.dataset.variantTitle + ' части';
        mobilePrice.textContent = option.dataset.variantPrice;
      });
    });

    const mainImage = root.querySelector('.tc-main-image img');
    root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.gallerySrc;
        mainImage.removeAttribute('srcset');
        mainImage.alt = thumb.dataset.galleryAlt;
        root.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    const reviewTrack = root.querySelector('[data-review-track]');
    const reviewPrevious = root.querySelector('[data-review-prev]');
    const reviewNext = root.querySelector('[data-review-next]');
    if (reviewTrack && reviewPrevious && reviewNext) {
      const moveReviews = (direction) => {
        reviewTrack.scrollBy({ left: reviewTrack.clientWidth * direction, behavior: 'smooth' });
      };
      reviewPrevious.addEventListener('click', () => moveReviews(-1));
      reviewNext.addEventListener('click', () => moveReviews(1));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werkbull-generator-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[id^="WerkbullLanding-"]');
    if (!root) return;
    const hiddenId = root.querySelector('.wb-variant-id');
    const price = root.querySelector('[data-current-price]');
    const compare = root.querySelector('[data-current-compare]');
    const saving = root.querySelector('[data-current-saving]');
    const mobilePrice = root.querySelector('[data-mobile-price]');
    const title = root.querySelector('[data-selection-title]');
    const text = root.querySelector('[data-selection-text]');
    const mainBuy = root.querySelector('[data-main-buy]');
    root.querySelectorAll('.wb-variant').forEach((card) => {
      card.addEventListener('click', () => {
        const input = card.querySelector('input');
        if (!input || input.disabled) return;
        root.querySelectorAll('.wb-variant').forEach((item) => item.classList.remove('is-selected'));
        card.classList.add('is-selected');
        input.checked = true;
        hiddenId.value = card.dataset.variantId;
        price.textContent = card.dataset.variantPrice;
        mobilePrice.textContent = card.dataset.variantPrice;
        compare.textContent = card.dataset.variantCompare || '';
        saving.hidden = !card.dataset.variantSaving || card.dataset.variantSaving === '0';
        saving.textContent = saving.hidden ? '' : `-${card.dataset.variantSaving}%`;
        const reinforced = card.dataset.reinforced === 'true';
        title.textContent = reinforced ? 'Избран: Подсилен двигател' : 'Избран: Стандартен двигател';
        text.textContent = reinforced ? 'С магнезиево покритие и 60 месеца гаранция за по-честа работа.' : 'За периодична употреба с 36 месеца гаранция.';
        root.querySelectorAll('[data-price-buy]').forEach((button) => button.textContent = `Добави в количката – ${card.dataset.variantPrice}`);
        mainBuy.disabled = false;
        mainBuy.textContent = 'Добави в количката →';
      });
    });
    const selected = root.querySelector('.wb-variant.is-selected');
    if (selected) selected.click();
  })();

  } catch(e) { console.error(e); }
})();
})();
